<template>
  <div :class="componentClassName">
    <slot>{{ label }}</slot>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';

export default {
  name: 'a-list-group-header',
  props: {
    class: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-list-group-header');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
};
</script>
